import { TmBaseError } from '@/core/error/tmBaseError'
import type { TmTransportErrorPayload } from '@/core/error/transport/types'

export class TmTransportError<T extends TmTransportErrorPayload = TmTransportErrorPayload> extends TmBaseError<T> {
  public name = 'TmTransportError'
}
